import { TFunction } from "i18n";
import { navigator } from "shared/services/navigator";
import applicationMap from "services/applicationMap";

export function getCancelButton(t: TFunction, text?: string) {
  return {
    text: text ?? t("common:button.label.cancel"),
    onClick: () => navigator.goTo(applicationMap.links.jobsSelfTapeRequests()),
    wrapperClassName: "mr-auto",
  };
}
